<template>
    <b-modal v-model="isModalOpen" hide-footer
             title="Dateieigenschaften ändern" @hide="reset()">
        <div class="record-files-edit-modal">
            <csp-desktop-info-card
                :cols="12"
                :form-context="currentFormContext"
                icon="inticon-users"
                title="Dateieigenschaften"
                @cancel-form="reset"
                @save="saveFileEditFormData">
                <csp-desktop-info-card-element
                    :form-context="currentFormContext"
                    label="Neuer Dateiname"
                    property="fileName"
                    :required="true"
                    type="text"/>

                <csp-desktop-info-card-element
                    :form-context="currentFormContext"
                    label="Zuordnung"
                    :options-loader="loadFileCategoryGroupOptions"
                    property="fileCategoryGroup"
                    :required="true"
                    type="autocomplete"/>

                <csp-desktop-info-card-element
                    :auto-select-single-option="true"
                    :dependencies="['fileCategoryGroup']"
                    :form-context="currentFormContext"
                    label="Kategorie"
                    :options-loader="loadFileCategoryOptions"
                    property="fileCategory"
                    :required="true"
                    type="autocomplete"/>
            </csp-desktop-info-card>
        </div>
    </b-modal>
</template>

<script>
import Container from '@services/Container';
import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
import FormContext from '@desktop/components/FormContext';

const container = Container.getInstance();
const recordRepository = container.getDesktopRecordRepository();

export default {
    name: 'FileEditModal',
    mixins: [FormDataMixin],
    props: {
        recordId: {
            type: Number,
            required: true,
        },
        fileId: {
            type: Number,
            default: null,
        },
    },
    emits: ['reset', 'updated'],
    data() {
        return {
            isModalOpen: true,
            initialFormContexts: {
                fileEditFormContext: new FormContext({
                    name: 'file-edit',
                    handleEditModeByQuery: false,
                    isInEditMode: true,
                }),
            },
        }
    },
    computed: {
        currentFormContext() {
            return this.initialFormContexts.fileEditFormContext;
        },
    },
    created() {
        this.loadForm();
    },
    methods: {
        loadFileCategoryGroupOptions() {
            return recordRepository.loadLegacySelectOptions(
                'fileCategoryGroups',
                {recordId: this.recordId}
            );
        },
        loadFileCategoryOptions() {
            return recordRepository.loadLegacySelectOptions(
                'fileCategory',
                {
                    fileCategoryGroupId: this.currentFormContext.form.getProperty('fileCategoryGroup'),
                    recordId: this.recordId,
                }
            );
        },
        loadForm() {
            const loadFunction = () => {
                return recordRepository.loadEditFileForm(this.recordId, this.fileId);
            }
            this.loadFormData(loadFunction);
        },
        reset() {
            this.currentFormContext.form.reset();
            this.$emit('reset');
        },
        saveFileEditFormData(formContext) {
            const saveFunction = (objectId, postData) => {
                return recordRepository.saveEditFileForm(this.recordId, this.fileId, postData);
            }
            this.saveFormData(formContext, saveFunction, false).then(() => {
                this.$emit('updated');
                this.reset();
            });
        },
    },
}
</script>
